export const SET_CURRENT_MENU = "SET_CURRENT_MENU";
